export default __webpack_public_path__ + "static/media/QiddiyaBack.9fdb8a9a.jpeg";